import { datadogRum } from '@datadog/browser-rum'

import { defineNuxtPlugin, useRuntimeConfig } from '#imports'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  datadogRum.init({
    applicationId: '82f0f581-bbbf-401b-8902-e6b69e502312',
    clientToken: 'pubb0ad046de0ffaffde65228ce830a736c',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'esg-app',
    env: config.public.APP_ENV,
    // TODO: コミットハッシュを取得して設定する
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [url => url.startsWith(config.public.APP_URL)],
    beforeSend() {
      if (config.public.APP_ENV === 'local') {
        return false
      }
      return true
    },
  })

  nuxtApp.vueApp.$nuxt.$router.afterEach((to) => {
    datadogRum.startView({
      name: to.name?.toString(),
    })
  })
})
